<template>
  <base-autocomplete-option :upcase="true">
    <span>{{ item[0] }}</span>
  </base-autocomplete-option>
</template>

<script>
import BaseAutocompleteOption from '@/components/inputs/base-autocomplete-option'

export default {
  components: { BaseAutocompleteOption },

  props: {
    item: {
      type: Array,
      required: true
    },
    searchText: {
      required: true,
      type: String
    }
  }
}
</script>
